__webpack_require__.hmrF = () => ("kdesigns." + __webpack_require__.h() + ".hot-update.json");